import {DeserializedRecord, deserializeItem, Deserializer} from "../Helpers";
import {Priority} from "../../modules/tasks/enums/Priority";

interface TaskCount extends DeserializedRecord<"count"> {
  notStartedCount: number
  activeCount: number
  completedCount: number
  failedCount: number
  assignedCount: Record<Priority, number>;
}

const deserializeTaskCount: Deserializer<TaskCount> = (data, included) => ({
  ...deserializeItem(data)
});

export {
  TaskCount, deserializeTaskCount
};
